import React, { useEffect, useMemo, useState } from 'react';
import {
	Slider,
	Select,
	Button,
	SelectOption,
	Input,
	Toast,
	Loader,
	MultiSelect,
	TextArea,
	Tooltip
} from '@kaleyra/emmy';
import 'antd/dist/antd.css';
import Styles from '../CallbackProfile.module.scss';
import { useTranslation } from 'react-i18next';
import { ChannelDynamicVariable, defaultResponse, methods } from '../constants';
import { validateHttpsURL, validateUrl } from '../../../utils/index';
import cn from 'classnames';
import CloseIcon from '../../../assets/CloseIcon.svg';
import ErrorIcon from '../../../assets/error.png';
import AddIcon from '../../../assets/AddIcon.svg';
import AddIconEnabled from '../../../assets/addV.png';
import { cloneDeep, isEmpty } from 'lodash';
import ErrorImage from '../../../components/ErrorImage/ErrorImage';
import { TITLE_VALIDATION_REGEX } from '../../../constants';
import EncProfile, { EncryptionData } from './EncProfile';
import AuthProfile, {AuthenticationData} from './AuthProfile';
import { validateIV, validateKey } from '../encryption-utils';
import CallbackRequiredProfile from './CallbackRequiredProfile';
import { ListDynamicVariables } from './ListDynamicVariables';
import { promisifyResponse } from '../../../utils/promisify-response';
import { validateURL } from '../utils/validate-url';
import FormDataProfile from './FormDataProfile';
import infoIcon from '../../../assets/InfoIcon.svg';
// import { Mentions } from 'antd';
import { useSelector } from 'react-redux';
import { IStateType } from '../../../store/models/root.interface';
import { CALLBACK_RETRY_ENABLED } from '../../../base';

export type MapStateToPropsType = {
	params: any;
};

export type MapDispatchToPropsType = {
	closeFilterModal: () => void;
	createCallbackProfile: (data: any, cb: (res: any) => void) => void;
	testCallbackProfile: (data: any, cb: (res: any) => void) => void;
	initializeAndLoadData: (filter: any, searchTer: string) => void;
	getCallbackProfileData: (id: string, cb: (res: any) => void) => void;
	updateCallbackProfile: (
		id: string,
		data: any,
		cb: (res: any) => void
	) => void;
	onSearchTextChange: (searchText: string) => void;
	clearFilters: () => void;
	getDynamicVar: (cb: (res: any) => void) => void;
};

export type DynamicVar = {
	value: string;
	description: string;
};
interface TransformedAuthHeaders {
	[key: string]: string;
  }

export type RetryConfigVar = { 
	timeInterval?: number; // in seconds
	timeout?: number; // also in seconds
}

type Header = { key: string; value: string };
type Headers = Array<Partial<Header>>;

const METHODS_WITH_BODY = ['POST', 'PUT', 'PATCH'];
const CallbackProfileCreate: React.FC<
	MapStateToPropsType & MapDispatchToPropsType
> = ({
	closeFilterModal,
	params,
	createCallbackProfile,
	testCallbackProfile,
	getCallbackProfileData,
	getDynamicVar,
	updateCallbackProfile,
	onSearchTextChange,
	clearFilters,
}) => {
		const [method, setMethod] = useState<string | undefined>(undefined);
		const [title, setTitle] = useState<string | undefined>(undefined);
		const [endpoint, setEndpoint] = useState<string>('');
		const [requestBody, setRequestBody] = useState<string>('');
		let [headers, setHeaders] = useState<Headers>([{}]);
		const [statusCode, setStatusCode] = useState(1);
		const [parameters, setParameters] = useState<string[]>([]);
		const [authHeaders, setAuthHeaders] = useState<Headers>([{}]);
		const [encryptionData, setEncryptionData] = useState<EncryptionData>({});
		const [authData, setAuthData] = useState<AuthenticationData>({})
		const [isEditMode, setIsEditMode] = useState(false);
		const [dynamicVariableResponse, setDynamicVariablesResponse] = useState<
			ChannelDynamicVariable[]
		>([]);
		const [requiredProfileData, setRequiredProfileData] = useState<
			string | null
		>(null);
		const [unsupportedTLSVersion, setUnsupportedTLSVersion] = useState<boolean | false>(false);

		const [requiredFormDataProfileData, setRequiredFormDataProfileData] = useState<
			string
		>('');
		const [statusFormDataProfileData, setStatusFormDataProfileData] = useState(false);
		const [urlError, setUrlError] = useState(false);
		const [timeoutError, setTimeOutError] = useState<any>({});
		const [timeIntervalError, setTimeIntervalError] = useState<any>({});
		const [fetchingEditData, setFetchingEditData] = useState(true);
		const [inProgress, setInProgress] = useState(false);
		const [testinProgress, setTestinProgress] = useState(false);
		const [requestBodyError, setRequestBodyError] = useState<any>({});
		const [enableLabel, setEnableLabel] = useState(false);
		const [editID, setEditID] = useState('');
		const [hover, setHover] = useState(false); // initial false
		const [channel, setChannel] = useState<string | undefined>(
			`${defaultResponse.source} - ${defaultResponse.description}`
		);
		const [channelChange, setChannelChange] = useState<boolean>(false);
		const [retries, setRetries] = useState<string | undefined>(); 
		const [retryConfigs, setRetryConfigs] = useState<RetryConfigVar[]>([]);
		const [selectedEvents, setSelectedEvents] = useState<
			string[] | undefined
		>();
		const [dynamicVariables, setDynamicVariables] = useState<DynamicVar[]>([]);
		const [listingVariables, setListingVariables] = useState<boolean>(false);
		const [requestTestError, setRequestTestError] = useState<any>({
			method:'',
			endpoint:'',
			iv:'',
			key:'',
		});

		const { callbacks_advanced_authentications } = useSelector((state: IStateType) => state.profile?.fullProfile);
		const {
			setDateTag,
			setMethodTag,
			setSearchText,
			mode,
			callbackProfileId,
			searchText,
			dateTag,
			methodTag,
			webhookTrigger,
			handlecallback
		} = params;

		const { t } = useTranslation();

		const retriesOptions = ['0','1','2'];


		const fetchProfileData = (profileData: any) => {

			const editData = profileData.data[0];

			if (editData.http_method) setMethod(editData.http_method);
			if (editData.url) setEndpoint(editData.url);
			if (editData.body) setRequestBody(editData.body);
			if (editData.status) setStatusCode(editData.status);
			if (editData.title && mode === 'edit') setTitle(editData.title);
			if (editData.title && mode === 'duplicate') setTitle(`Copy-${editData.title}`);
			if (editData.headers) {
				let headers = createHeaders(editData.headers);
				setHeaders(headers);
				//Sets up headers for content-type formdata and urlencoded
				if (JSON.parse(editData.headers)["Content-Type"] === 'multipart/form-data'){
					setRequiredFormDataProfileData('formData');
				} else{
					if (JSON.parse(editData.headers)["Content-Type"] === 'application/x-www-form-urlencoded'){
						setRequiredFormDataProfileData('urlEncoded');
					 } else {
						if(statusFormDataProfileData === false){
						   headers = headers.filter((item: { value: string; }) => item.value !== 'multipart/form-data' && item.value !== 'application/x-www-form-urlencoded');
						   setHeaders(headers);
					   }
					 }
					 
				}
				
			}

			if (editData.profile_id) setEditID(editData?.profile_id);
			if (editData.channel) setChannel(editData.channel);
			if (editData.events) setSelectedEvents(JSON.parse(editData.events));

			if (editData.enc !== '{}') {
				try {
					const parsedEnc = JSON.parse(editData.enc);
					const encryptData: EncryptionData = {
						algorithm: {
							data: parsedEnc.algo,
						},
						key: {
							data: parsedEnc.key,
						},
						iv: {
							data: parsedEnc.IV,
						},
					};
					setEncryptionData(encryptData);
					setParameters(parsedEnc.params || []);
				} catch (err) {
					// editData.enc is not a valid JSON
					// Something is wrong, need to know how to handle this
				}
			}
			if (editData.retry) {
				const profileRetry = JSON.parse(editData.retry);
				setRetries(profileRetry.count.toLocaleString());
				if (profileRetry.count !== 0) {
					let retryArr: RetryConfigVar[] = [];
					let timeout: any = {}
					let timeInterval: any = {}
					for (let i = 0; i < profileRetry.count; i++) {
						const newElem = {
							timeInterval: profileRetry.interval[i]
								? profileRetry.interval[i]
								: undefined,
							timeout: profileRetry.timeout[i]
								? profileRetry.timeout[i]
								: undefined,
						};
						retryArr.push(newElem);
						timeout[i] = profileRetry.timeout[i]>60000
						timeInterval[i] = profileRetry.interval[i]>60
					}
					setRetryConfigs(retryArr);
					setTimeOutError(timeout);
					setTimeIntervalError(timeInterval);
				}
			}
			if (editData.authentication !== '{}') {
				try {
					const parsedAuth = editData.authentication;
					const AuthData: AuthenticationData = {
						authType: {
							data: parsedAuth.authType,
						},
						httpMethod: {
							data: parsedAuth.method,
						},
						authUrl: {
							data: parsedAuth.url,
						},
						clientId: {
							data: parsedAuth.client_id,
						},
						clientSecret:{
							data: parsedAuth.client_secret,
						},
						customBody:{
							data: JSON.stringify(parsedAuth.customBody) === '[]'? '': JSON.stringify(parsedAuth.customBody),
						},
						tokenFieldPath:{
							data: parsedAuth.tokenFieldPath,
						},
						expirationFieldPath:{
							data: parsedAuth.expirationFieldPath,
						},
						authAlgorithm : {
							data: parsedAuth.algorithm
						}
					};
					setAuthData(AuthData);
					setIsEditMode(true)
					const oauthHeaders = createHeaders(JSON.stringify(parsedAuth.custom_params.headers))
					setAuthHeaders(oauthHeaders);
				} catch (err) {
					// editData.authentication is not a valid JSON
					// Something is wrong, need to know how to handle this
				}
			}

			if (editData.response_message)
				setRequiredProfileData(editData?.response_message || null);

			if (editData.unsupportedTLSVersion)
				setUnsupportedTLSVersion(true);			
				
			setFetchingEditData(false);
		};

		// Fetch profile and dynamic vars from server
		useEffect(() => {
			const promisifyDynamicVar = promisifyResponse(getDynamicVar);
			const promisifyProfile = promisifyResponse(getCallbackProfileData);

			if (mode !== 'edit' && mode !== 'duplicate')
				promisifyDynamicVar().then((response) => {
					if (!response.data) return;
					setDynamicVariablesResponse([
						...response.data,
						defaultResponse,
					]);
				});
			else fetchAll();

			async function fetchAll() {
				const [dynamic, profile] = await Promise.all([
					promisifyDynamicVar(),
					promisifyProfile(callbackProfileId),
				]);
				fetchProfileData(profile);

				if (!dynamic.data) return;
				setDynamicVariablesResponse([...dynamic.data, defaultResponse]);

			}
		}, [getDynamicVar, mode, getCallbackProfileData]);

		const events = dynamicVariableResponse?.find(
			(item) => item.source === channel
		)?.events;

		useEffect(() => {
			if (mode !== 'edit' && mode !== 'duplicate' || channelChange) {
				if (!events || events.length === 0)
					setSelectedEvents(undefined);
				else setSelectedEvents(events.map((event) => event.name));
			}
		}, [channel, events]);

		// Set the dynamicVariables
		useEffect(() => {
			if (!events || !selectedEvents) return setDynamicVariables([]);

			const dynamicVars: Array<DynamicVar> = [];

			const pickedEvents = events?.filter((event) =>
				selectedEvents.includes(event.name)
			);

			for (const pickedEvent of pickedEvents) {
				for (const variable of pickedEvent.variables) {
					if (!method || !variable.methods.includes(method.toUpperCase()))
						continue;

					const dynamicVar: DynamicVar = {
						value: variable.name,
						description: variable.description,
					};

					const isPresent =
						dynamicVars.findIndex(
							(element) => element.value === dynamicVar.value
						) !== -1;

					if (isPresent) continue;
					dynamicVars.push(dynamicVar);
				}
			}

			setDynamicVariables(dynamicVars);
		}, [selectedEvents, events, method]);

		useEffect(() => {
			if (!requestBody) {
				setRequestBodyError({});
			}
		}, [requestBody]);


		const createHeaders = (headers: any) => {
			const parsedHeaders = JSON.parse(headers);
			const tempHeaders: any = [];
			if (!parsedHeaders || isEmpty(parsedHeaders)) return [{}];
			Object.keys(parsedHeaders).forEach((key: string) => {
				if(parsedHeaders[key] === 'application/x-www-form-urlencoded'){
					setRequiredFormDataProfileData('urlEncoded');
					setStatusFormDataProfileData(true);
				}
				if (parsedHeaders[key] === 'multipart/form-data'){
					setRequiredFormDataProfileData('formData');
					setStatusFormDataProfileData(true);
				}
				tempHeaders.push({
					key,
					value: parsedHeaders[key],
				});
			});
			return tempHeaders;
		};

		const clearValuesLogic = () => {
			if (searchText?.length && (dateTag || methodTag?.length)) {
				setSearchText('');
				setDateTag(null);
				setMethodTag('');
				clearFilters();
			} else if (searchText) {
				setSearchText('');
				onSearchTextChange('');
			} else if (dateTag || methodTag?.length) {
				setDateTag(null);
				setMethodTag('');
				clearFilters();
			}
		};

		const titleValidateCheck = useMemo((): 'error' | 'default' => {
			if (title === undefined) return 'default';
			let regex = TITLE_VALIDATION_REGEX.test(title);
			if (title.trim().length < 3 || regex) return 'error';
			return 'default';
		}, [title]);

		const titleValidateError = useMemo(() => {
			if (title === undefined)
				return (
					<ErrorImage
						hideIcon={true}
						type="warning"
						title={t('titleSpcCharNotAllowed')}
					/>
				);
			if (!title || title.trim().length === 0) {
				return <ErrorImage title={t('titleReq')} />;
			} else if (TITLE_VALIDATION_REGEX.test(title)) {
				return <ErrorImage title={t('titleSpcCharNotAllowed')} />;
			} else if (title.trim().length < 3) {
				return <ErrorImage title={t('min3Char')} />;
			}
			return (
				<ErrorImage
					hideIcon={true}
					type="warning"
					title={t('titleSpcCharNotAllowed')}
				/>
			);
		}, [title]);

		const validateUrlCheck = (): 'error' | undefined => {
			if (
				!validateURL(endpoint) ||
				!validateHttpsURL('urlLength', endpoint, 2048)
			)
				return 'error';
			return undefined;
		};

		const validateErrorUrl = () => {
			if (!endpoint || endpoint.trim().length === 0) {
				return (
					<span>
						<img
							style={{ marginRight: '0.5rem' }}
							src={ErrorIcon}
							className={Styles.errorIcon}
							alt=""
						/>
						{t('titleReq')}
					</span>
				);
			} else if (!validateURL(endpoint)) {
				return (
					<span>
						<img
							style={{ marginRight: '0.5rem' }}
							src={ErrorIcon}
							className={Styles.errorIcon}
							alt=""
						/>
						{t('validInput')}
					</span>
				);
			} else if (!validateHttpsURL('urlLength', endpoint, 2048)) {
				return (
					<span>
						<img
							style={{ marginRight: '0.5rem' }}
							src={ErrorIcon}
							className={Styles.errorIcon}
							alt=""
						/>
						{t('endpointValid')}
					</span>
				);
			}
			return <></>;
		};

		const saveDisabled = () => {
			if (!title) return true;
			const regex = TITLE_VALIDATION_REGEX.test(title);
			if (METHODS_WITH_BODY.includes(method ?? '') && !requestBody)
				return true;
			if (regex || title.length < 3) return true;
			if (requestBody && requestBodyError['error']) return true;
			if (!validateURL(endpoint)) return true;
			if (!validateHttpsURL('urlLength', endpoint, 2048)) return true;
			if (!title || !method || !endpoint || inProgress) return true;
			for (const timeInterval in timeIntervalError) {
				if(timeIntervalError[timeInterval])return true
			}

			for (const timeOut in timeoutError) {
				if(timeoutError[timeOut])return true
			}

			const { authType, httpMethod, authUrl, clientId, clientSecret, tokenFieldPath, expirationFieldPath, authAlgorithm } = authData ;
			const authValues = [ authType?.data, httpMethod?.data, authUrl?.data, clientId?.data, clientSecret?.data, tokenFieldPath?.data, expirationFieldPath?.data, authAlgorithm?.data ] 
			const allAuthMandatoryFiledsFilled = authValues.every((authValue)=>authValue)
			const fewAuthMandatoryFiledsFilled = authValues.every((authValue)=> !authValue)

			if (allAuthMandatoryFiledsFilled) return false;
			if (!fewAuthMandatoryFiledsFilled) return true;

			// EncryptData is valid if
			// - All the mandatory keys are filled
			// - All the mandatory keys are not filled
			const { algorithm, key, iv } = encryptionData;
			const values = [algorithm?.data, key?.data, iv?.data];
			const everythingFilled = values.every((value) => value);
			const nothingFilled = values.every((value) => !value);

			// Means that some fields are filled
			if (nothingFilled) return false;

			// Means that some fields are filled, but we needed every fields
			if (!everythingFilled) return true;

			// Here all fields are filled, let's validate them
			// We can safely use ! because we already checked that every field was not falsy
			const isValidKey = validateKey(values[1]!, values[0]!) === null;
			const isValidIV = validateIV(values[2]!) === null;

			return !(isValidKey && isValidIV);
		};

		const testValidator = () => {
			if (!method) {
				return true;
			}

			if (!endpoint && !validateURL(endpoint)) {
				return true;
			}
		
			if (METHODS_WITH_BODY.includes(method ?? '') && !requestBody) {
				return true;
			}
			// if (requestBody && requestBodyError['error']) return true;
			if (METHODS_WITH_BODY.includes(method ?? '') && requestBody === '{}') {
				return true;
			}

			if (!validateHttpsURL('urlLength', endpoint, 2048)) return true;
			if (!method || !endpoint || testinProgress) return true;
			// EncryptData is valid if
			// - All the mandatory keys are filled
			// - All the mandatory keys are not filled
			const { algorithm, key, iv } = encryptionData;
			const values = [algorithm?.data, key?.data, iv?.data];


			const everythingFilled = values.every((value) => value);
			const nothingFilled = values.every((value) => !value);
			// Means that some fields are filled
			if (nothingFilled) return false;
			// Means that some fields are filled, but we needed every fields
			if (!everythingFilled) return true;
			// Here all fields are filled, let's validate them
			// We can safely use ! because we already checked that every field was not falsy
			const isValidKey = validateKey(values[1]!, values[0]!) === null;
			const isValidIV = validateIV(values[2]!) === null;
			return !(isValidKey && isValidIV);
		};

		const mapHeaders = (headers: Headers, requiredFormDataProfileData: any) => {
			const newHeaders: Record<string, string> = {};

			for (const { key, value } of headers) {
				if (!key || !value) continue;
				newHeaders[key] = value;
			}

			if (requiredFormDataProfileData === 'urlEncoded'){
				newHeaders['Content-Type'] = 'application/x-www-form-urlencoded';
			}
			if (requiredFormDataProfileData === 'formData'){
				newHeaders['Content-Type'] = 'multipart/form-data';
			}

			return newHeaders;
		};

		const addMoreEnabledCheck = () => {
			let clonedHeaders = cloneDeep(headers);
			for (let i = 0; i < headers.length; i++) {
				if (clonedHeaders[i]['key'] && clonedHeaders[i]['value']) continue;
				return false;
			}
			return true;
		};

		const validateRequestBody = () => {
			if (!requestBody && METHODS_WITH_BODY.includes(method ?? '')) {
				setRequestBodyError({
					error: true,
					msg: t('titleReq'),
				});
			}
			if (requestBody && METHODS_WITH_BODY.includes(method ?? '')) {
				try {
					JSON.parse(requestBody);
					setRequestBodyError({
						error: false,
						msg: '',
					});
				} catch (err) {
					setRequestBodyError({
						error: true,
						msg: t('invalidJsonMsg'),
					});
					return;
				}
			}
		};

		const handleSave = () => {
			//update retry configuration
			let intervalArr: any = [];
			let timeoutArr: any = [];
			let retry = null;
			retryConfigs.map((item) => {
				intervalArr.push(item.timeInterval);
				timeoutArr.push(item.timeout);
			});
			if (retries) {
				retry =
					parseInt(retries) === 0
						? {
								count: 0,
						  }
						: {
								count: parseInt(retries),
								interval: intervalArr,
								timeout: timeoutArr,
						  };
			}
			
			let data: Record<string, unknown> = {
				title: title || '',
				http_method: method,
				url: endpoint,
				status: statusCode,
				headers: mapHeaders(headers,requiredFormDataProfileData),
				response_message: requiredProfileData,
				body: JSON.parse(requestBody || '{}'),
				retry: retry,
			};
			
			// dispatch the call

			// Add enc key to data only if encryptionData is not
			// an empty object
			if (Object.keys(encryptionData).length > 0) {
				// Transform encryptionData to an object which is compliant
				// with the requirements
				const enc: Record<string, unknown> = {
					algo: encryptionData.algorithm?.data,
					key: encryptionData.key?.data,
					IV: encryptionData.iv?.data,
				};

				// If the array is valid, add it to the data
				// We only pick the valid params,
				// So we discard '', undefined, null, [], {}
				// Check if the length of the array is greater than 0
				// Because we don't want to add params key if it's empty
				if (parameters.length !== 0 && parameters.some(Boolean)) {
					enc['params'] = parameters.filter(Boolean);
				}

				data['enc'] = enc;
			}
			
			if (Object.keys(authData).length > 0) {
				const auth: Record<string, unknown> = {
					authType: authData.authType?.data,
					method: authData.httpMethod?.data,
					url: authData.authUrl?.data,
					client_id : authData.clientId?.data,
					client_secret : authData.clientSecret?.data,
					customBody : JSON.parse(authData.customBody?.data || '{}'),
					tokenFieldPath : authData.tokenFieldPath?.data,
					expirationFieldPath : authData.expirationFieldPath?.data,
					algorithm : authData.authAlgorithm?.data,
					custom_params : {
						headers : TransformCustomHeaders(authHeaders)
				}
			};
				data['authentication'] = auth;
			}

			if (channel) data['channel'] = channel;
			if (selectedEvents) data['events'] = selectedEvents;

			if (mode === 'create' || mode === 'duplicate') {
				// create callback profile
				setInProgress(true);
				createCallbackProfile(data, (res) => {
					setInProgress(false);
					// initializeAndLoadData({}, 'title')
					if (isEmpty(res && res.error)) {
						clearValuesLogic();
						Toast(t('callbackSuccess'), 'success');
						closeFilterModal();
						if(webhookTrigger){
							handlecallback(true);
						}
					} else {
						Toast(res.message || t('mainWentWrong'), 'error');
					}
				});
			} else {
				// update callback profile
				setInProgress(true);
				data.profile_id = editID;
				updateCallbackProfile(params.callbackProfileId, data, (res) => {
					setInProgress(false);
					if (isEmpty(res && res.error)) {
						clearValuesLogic();
						Toast(t('callbackUpdate'), 'success');
						closeFilterModal();
					} else {
						Toast(res.message || t('mainWentWrong'), 'error');
					}
				});
			}
		};
  
		  const TransformCustomHeaders = (authHeaders: Headers): TransformedAuthHeaders => {
			const transformedHeaders: TransformedAuthHeaders = {};
			authHeaders.forEach(header => {
			  if (header.key && header.value) {
				transformedHeaders[header.key] = header.value;
			  }
			});
			return transformedHeaders;
		  };
		  

		const handleTest = () => {
			let enteredData: Record<string, unknown> = {
				http_method: method,
				url: endpoint,
				headers: mapHeaders(headers, requiredFormDataProfileData),
				response_message: requiredProfileData,
				body: !requestBodyError['error']
					? JSON.parse(requestBody || '{}')
					: null,
			};
			if (Object.keys(encryptionData).length > 0) {
				// Transform encryptionData to an object which is compliant
				// with the requirements
				const enc: Record<string, unknown> = {
					algo: encryptionData.algorithm?.data,
					key: encryptionData.key?.data,
					IV: encryptionData.iv?.data,
				};
				// If the array is valid, add it to the data
				// We only pick the valid params,
				// So we discard '', undefined, null, [], {}
				// Check if the length of the array is greater than 0
				// Because we don't want to add params key if it's empty
				if (parameters.length !== 0 && parameters.some(Boolean)) {
					enc['params'] = parameters.filter(Boolean);
				}
				enteredData['enc'] = enc;
			}
			if (Object.keys(authData).length > 0) {
				const auth: Record<string, unknown> = {
					authType: authData.authType?.data,
					method: authData.httpMethod?.data,
					url: authData.authUrl?.data,
					client_id: authData.clientId?.data,
					client_secret: authData.clientSecret?.data,
					customBody: JSON.parse(authData.customBody?.data || '{}'),
					tokenFieldPath: authData.tokenFieldPath?.data,
					expirationFieldPath: authData.expirationFieldPath?.data,
					algorithm: authData.authAlgorithm?.data,
					custom_params: {
						headers: TransformCustomHeaders(authHeaders),
					},
				};
				enteredData['authentication'] = auth;
			}
			enteredData['test_callback'] = true;
			const apiData = {
				data: [enteredData],
			};
			setRequestTestError({
				...requestTestError,
				method: '',
				endpoint: '',
				iv: '',
				key: '',
			});
			setTestinProgress(true);

			if(!validateUrl(apiData.data[0].url as string)){
				Toast(t('callbackTestValidationURLNotValid'), 'error');
				setTestinProgress(false);
				return;
			}

			testCallbackProfile(apiData, (res: { message: any; error: any; }) => {				

				if(isEmpty(apiData.data[0].http_method) || isEmpty(apiData.data[0].url)){
					Toast(res.message || t('callbackTestValidationMissingFieldsError'), 'error');
				}
					
				Toast(t('callbackTestSuccess'), 'success');
				setTestinProgress(false);
			});
		};

		const removeHeaderPair = (index: number) => {
			if (headers.length === 1) {
				setHeaders([{}]);
				return;
			}
			const clonedHeaders = cloneDeep(headers);
			clonedHeaders.splice(index, 1);
			setHeaders(clonedHeaders);
		};

		const setKeyValuePair = (value: string, index: number, type: string) => {
			const clonedHeaders = cloneDeep(headers);
			clonedHeaders[index] = {
				...clonedHeaders[index],
				[type]: value,
			};
			setHeaders(clonedHeaders);
		};

		const renderFooter = () => {
			return (
				<div className={Styles.footer}>
					<div>
						<span>
						<Button 
						type="tertiary"
						disabled={testValidator()}
						onClick={() => handleTest()}
						>
							{t('mainTest')}
						</Button>
						</span>
					</div>
					<div>
						<span>
							<span className={Styles.cancelBtn}>
								<Button
									type="tertiary"
									onClick={() => closeFilterModal()}
								>
									{t('mainCancel')}
								</Button>
							</span>
							<Button
								type="primary"
								disabled={saveDisabled()}
								onClick={handleSave}
							>
								{t('mainSave')}
							</Button>
						</span>
					</div>
				</div>
			);
		};

		const addMoreEnabled = addMoreEnabledCheck();

		const checkLabel = (header: string, key: string) => {
			if (enableLabel === false) {
				if (header === undefined) {
					return undefined;
				} else {
					return key;
				}
			} else {
				return key;
			}
		};

		const onChangeEvents = (value: string[]) => {
			setSelectedEvents(value);
		};

		if (mode === 'edit' && fetchingEditData) {
			return (
				<Slider
					title={t('editCallbackProfile')}
					containerId="root-modal"
					onClose={() => closeFilterModal()}
					visibility={true}
					footer={renderFooter()}
				>
					<Loader />
				</Slider>
			);
		}

		if (mode === 'duplicate' && fetchingEditData) {
			return (
				<Slider
					title={t('dulicateCallbackProfile')}
					containerId="root-modal"
					onClose={() => closeFilterModal()}
					visibility={true}
					footer={renderFooter()}
				>
					<Loader />
				</Slider>
			);
		}
		//remove from headers accordingly if state of enable form data options is disabled 
		if (!statusFormDataProfileData){
			headers = headers.filter((item) => item.value !== 'application/x-www-form-urlencoded' && item.value !== 'multipart/form-data')
		}
		else {
			if (requiredFormDataProfileData === '')
			headers = headers.filter((item) => item.key !== 'Content-Type');
			if (requiredFormDataProfileData === 'formData'){
				headers.forEach((item) => {if (item.key === 'Content-Type') item.value = 'multipart/form-data'});
			}
			if (requiredFormDataProfileData === 'urlEncoded'){
				headers.forEach((item) => {if (item.key === 'Content-Type') item.value = 'application/x-www-form-urlencoded'});
			}
		}
		const mentions = dynamicVariables.map((variable) => ({
			value: variable.value,
			label: variable.description,
			key: variable.value,
		}));

		return (
			<Slider
				title={
					mode === 'create'
						? t('addCallbackProfile')
						: mode === 'edit'
						? t('editCallbackProfile')
						: t('duplicateCallbackProfile')
				}
				containerId="root-modal"
				onClose={() => closeFilterModal()}
				visibility={true}
				footer={renderFooter()}
			>
				<div className={cn(Styles.callbackProfileCreate)}>
					<Input
						value={title}
						onChange={(e) => {
							let val = e.target.value;
							// if (val.length > 75) return;
							setTitle((val || '').slice(0, 75));
						}}
						label={t('mainTitle')}
						placeholder={t('mainTitle')}
						className={cn(Styles.mrgBtm)}
						style={{
							backgroundColor:
								titleValidateCheck === 'error'
									? 'rgba(241, 108, 123, 0.1)'
									: '',
						}}
						bottomLabelType={titleValidateCheck}
						bottomLabel={titleValidateError}
						showBottomLabelSpace
					/>
					<Select
						value={channel}
						placeholder={t('selChannelApi')}
						label={t('selChannelApi')}
						onChange={(val) => {
							setChannel(val as string);
							setChannelChange(true);
						}}
						className={cn(Styles.mrgBtm)}
						defaultValue={`${defaultResponse.source} - ${defaultResponse.description}`}
						disabled={dynamicVariableResponse.length === 0}
						showBottomLabelSpace={false}
					>
						{dynamicVariableResponse.map((item) => (
							<SelectOption key={item.source} value={item.source}>
								{item.source} - {item.description}
							</SelectOption>
						))}
					</Select>
					<MultiSelect
						placeholder={t('selEvent')}
						onChange={onChangeEvents as any} // For some reason, the type of this function is not compatible with the type of the Select component
						mode="multiple"
						className={cn(Styles.mrgBtm)}
						disabled={!events || events?.length === 0}
						bottomLabel={<span>{t('dynamicVarEvents')}</span>}
						showBottomLabelSpace
						bottomLabelType="default"
						value={selectedEvents}
					>
						{events?.map((item) => (
							<SelectOption key={item.name} value={item.name}>
								{item.description}
							</SelectOption>
						))}
					</MultiSelect>

					<div className={cn(Styles.compHeader, Styles.mrgTop)}>
						{t('httpMethod')}
					</div>
					<div className={cn(Styles.mrgBottomSelectMethod)}>
						<Select
							value={method}
							label={t('selMethod')}
							placeholder={t('selMethod')}
							onChange={(val: any) => {
								setMethod(val);
								setRequestTestError({
									...requestTestError,
									method: '',
								});
							}}
							className={cn(Styles.mrgBtm)}
							style={{
								backgroundColor:
									requestTestError.method !== 'error'
										? ''
										: 'rgba(241, 108, 123, 0.1)',
							}}
							bottomLabelType={
								requestTestError.method !== 'error'
									? 'default'
									: 'error'
							}
							bottomLabel={
								requestTestError.method !== 'error' ? (
									''
								) : (
									<ErrorImage title={t('titleReq')} />
								)
							}
							showBottomLabelSpace={method ? true : false}
						>
							{methods.map((item) => (
								<SelectOption
									key={item.value}
									value={item.value}
								>
									{item.key}
								</SelectOption>
							))}
						</Select>
					</div>
					{method && (
						<>
							<Input
								value={endpoint}
								onChange={(e) => {
									setEndpoint(e.target.value);
									setRequestTestError({
										...requestTestError,
										endpoint: '',
									});
								    testValidator();
								}}
								label={t('enterEndpoint')}
								placeholder={t('enterEndpoint')}
								className={cn(Styles.mrgBtm)}
								style={{
									backgroundColor:
										requestTestError.endpoint === 'error'
											? 'rgba(241, 108, 123, 0.1)'
											: '',
								}}
								bottomLabelType={
									requestTestError.endpoint === 'error' &&
									validateUrlCheck() === 'error'
										? 'error'
										: 'default'
								}
								onBlur={() => setUrlError(true)}
								bottomLabel={
									requestTestError.endpoint === 'error' &&
									validateUrlCheck() === 'error' ? (
										<ErrorImage title={t('titleReq')} />
									) : (
										''
									)
								}
								showBottomLabelSpace={
									endpoint && urlError && validateUrlCheck()
										? true
										: false
								}
							/>

							<p className={Styles.warningText}>{unsupportedTLSVersion && t('unsupportedTLSVersionMessage')}</p>                            
							<div className={Styles.containerDynamicVar}>
								<div>
									<div
										className={Styles.compHeader}
										style={{ marginBottom: 0 }}
									>
										{t('dynamicVariablesHeader')}
									</div>
									<p className={Styles.descriptionText}>
										{t('dynamicVariablesDescription')}
									</p>
								</div>
								<div>
									<Button
										onClick={() =>
											setListingVariables(true)
										}
										type="secondary"
										small
										disabled={dynamicVariables.length === 0}
									>
										{t('BLD00371')}
									</Button>
								</div>
							</div>
							{METHODS_WITH_BODY.includes(method) && (
								<>
									<TextArea
										value={requestBody}
										onChange={(e) =>
											setRequestBody(e.target.value)
										}
										onBlur={() => validateRequestBody()}
										label={t('reqBody')}
										placeholder={t('reqBody')}
										className={cn(Styles.mrgBtm)}
										style={{
											backgroundColor: requestBodyError[
												'error'
											]
												? 'rgba(241, 108, 123, 0.1)'
												: '',
										}}
										bottomLabelType={
											requestBodyError['error']
												? 'error'
												: 'default'
										}
										bottomLabel={
											requestBodyError['error'] ? (
												<span>
													<ErrorImage
														title={t(
															requestBodyError[
																'msg'
															]
														)}
													/>
												</span>
											) : (
												<></>
											)
										}
										showBottomLabelSpace
									/>
								</>
							)}
							{CALLBACK_RETRY_ENABLED && (
								<>
							<div className={cn(Styles.compHeader)}>
								<span
									className={Styles.compHeader}
									style={{ marginRight: '0.25rem' }}
								>
									{t('retriesHeader')}
								</span>

								<Tooltip title={t('retriesWarning')}>
									<img
										className={Styles.infoIcon}
										src={infoIcon}
										alt="close"
										title=""
									/>
								</Tooltip>
							</div>
							<div style={{ marginBottom: '1rem' }}>
								<Select
									value={retries}
									placeholder={t('nRetriesDescription')}
									label={t('nRetriesDescription')}
									onChange={(val: any) => {
										let retryArr: RetryConfigVar[] = [];
										let newElem = {
											timeInterval: undefined,
											timeout: undefined,
										};
										let timeoutErrorObj:any = {}
										let timeIntervalErrorObj: any = {}
										setRetries(val);
										for (
											let i = 0;
											i < parseInt(val);
											i++
										) {
											timeoutErrorObj[i] = timeoutError[i]?? false
											timeIntervalErrorObj[i] = timeIntervalError[i]?? false
											retryArr.push(
												retryConfigs[i]?? newElem
											)
										}
										setRetryConfigs(retryArr);
										setTimeOutError(timeoutErrorObj)
										setTimeIntervalError(timeIntervalErrorObj)
									}}
									showBottomLabelSpace={false}
								>
									{retriesOptions.map((item) => (
										<SelectOption key={item} value={item}>
											{item}
										</SelectOption>
									))}
								</Select>
							</div>
							{retryConfigs.map((item, index) => {
								return (
									<div key={'retry-time-params-' + index}>
										<p className={Styles.descriptionText}>
											{index === 0
												? t('firstRetryLabelSection')
												: t('secondRetryLabelSection')}
										</p>
										<div className={Styles.retryModule}>
										<div className={Styles.headersPair}>
											<Input
												className={cn(
													Styles.keyValuePair
												)}
												placeholder={t(
													'timeIntervalInSeconds'
												)}
												label={t(
													'timeIntervalInSeconds'
												)}
												key={
													'retry-time-interval-' +
													index
												}
												value={
													item.timeInterval
														? item.timeInterval.toLocaleString()
														: ''
												}
												onChange={(e) => {
													const value = e.target.value.replaceAll(',','')
													if(/^[0-9]*$/gm.test(value)){
														let config;
														config = [...retryConfigs];
														config[index] = {
															...retryConfigs[index],
															timeInterval: parseInt(
																value
															),
														};
														if(parseInt(value)>60){
															setTimeIntervalError({
																...timeIntervalError, 
																[index]: true,
															})
														}
														else {
															setTimeIntervalError({
																...timeIntervalError, 
																[index]: false,
															})
														}

														setRetryConfigs(config);
													}
												}}
												bottomLabelType={
													timeIntervalError[index]
														? 'error'
														: 'default'
												}
											/>
											<Input
												className={cn(
													Styles.keyValuePair,
													Styles.mrgLeftSm
												)}
												size={'small'}
												key={'retry-timeout-' + index}
												placeholder={t(
													'timeoutInMilliSeconds'
												)}
												label={t('timeoutInMilliSeconds')}
												value={
													item.timeout
														? item.timeout.toLocaleString()
														: ''
												}
												onChange={(e) => {
													const value = e.target.value.replaceAll(',','')
													if(/^[0-9]*$/gm.test(value)){
														let config;
														config = [...retryConfigs];
														config[index] = {
															...retryConfigs[index],
															timeout: parseInt(
																value
															),
														};

														if(parseInt(value)>60000){
															setTimeOutError({
																...timeoutError, 
																[index]: true,
															})
														}
														else {
															setTimeOutError({
																...timeoutError, 
																[index]: false,
															})
														}
														setRetryConfigs(config);
													}
												}}
												bottomLabelType={
													timeoutError[index]
														? 'error'
														: 'default'
												}
											/>
											
										</div>
										<div style={{display:"flex"}}>
											<span className={Styles.retryTimeIntervalError}>
												{
													timeIntervalError[index] ?
													( <ErrorImage title={t('timeIntervalError')}/> ) : (<></>)
												}
											</span>
											<span className={Styles.retryTimeOutError}>
												{
													timeoutError[index] ? 
													( <ErrorImage title={t('timeOutError')}/>) : (<></>)
												}
											</span>
										</div>
										<div>
										</div>
									</div>
									</div>
								);
							})}
							</>
							)}
							<div>
								<FormDataProfile
									requiredFormDataProfileData={
										requiredFormDataProfileData
									}
									setFormDataProfileData={
										setRequiredFormDataProfileData
									}
									setStatusFormDataProfileData={
										setStatusFormDataProfileData
									}
									statusFormDataProfileData={
										statusFormDataProfileData
									}
								/>
							</div>
							<br />
							<div className={Styles.compSubHeader}>
								{t('headerOptional')}
							</div>
							{headers.map((header: any, index: number) => {
								return (
									<div
										className={Styles.headersPair}
										key={index}
									>
										<Input
											className={cn(
												Styles.keyValuePair,
												Styles.mrgBtm
											)}
											value={header['key']}
											onChange={(e) =>
												setKeyValuePair(
													e.target.value,
													index,
													'key'
												)
											}
											label={checkLabel(
												header['key'],
												t('key')
											)}
											placeholder={t('key')}
											onFocus={() => setEnableLabel(true)}
											showBottomLabelSpace={false}
											onBlur={() => setEnableLabel(false)}
										/>
										<Input
											className={cn(
												Styles.keyValuePair,
												Styles.mrgLeftSm,
												Styles.mrgBtm
											)}
											value={header['value']}
											onChange={(e) =>
												setKeyValuePair(
													e.target.value,
													index,
													'value'
												)
											}
											label={checkLabel(
												header['value'],
												t('value')
											)}
											placeholder={t('value')}
											onFocus={() => setEnableLabel(true)}
											showBottomLabelSpace={false}
											onBlur={() => setEnableLabel(false)}
										/>
										<img
											className={Styles.closeIcon}
											src={CloseIcon}
											alt=""
											onClick={() =>
												removeHeaderPair(index)
											}
										/>
									</div>
								);
							})}
							<div>
								<span
									className={Styles.addMoreContainer}
									onClick={() =>
										addMoreEnabled
											? setHeaders((items: any) => [
													...items,
													{},
											  ])
											: undefined
									}
								>
									<img
										src={
											addMoreEnabled
												? AddIconEnabled
												: AddIcon
										}
										alt=""
									/>
									<span
										className={cn(
											Styles.addMore,
											addMoreEnabled ? Styles.enabled : ''
										)}
									>
										{t('addMore')}
									</span>
								</span>
								<EncProfile
									encryptionData={encryptionData}
									setEncryptionData={setEncryptionData}
									requestTestError={requestTestError}
									setRequestTestError={setRequestTestError}
									parameters={parameters}
									setParameters={setParameters}
								/>
								<div style={{ marginBottom: '1.5rem' }} />
								<CallbackRequiredProfile
									requiredProfileData={requiredProfileData}
									setRequiredProfileData={
										setRequiredProfileData
									}
								/>
								<div style={{ marginBottom: '1.5rem' }} />
								{callbacks_advanced_authentications == 1 && (
									<AuthProfile
										authData={authData}
										setAuthData={setAuthData}
										authHeaders={authHeaders}
										setAuthHeaders={setAuthHeaders}
										isEditMode={isEditMode}
									/>
								)}
							</div>
						</>
					)}
				</div>
				<ListDynamicVariables
					dynamicVariables={dynamicVariables}
					visible={listingVariables}
					onClose={() => setListingVariables(false)}
					queryString={!METHODS_WITH_BODY.includes(method ?? '')}
				/>
			</Slider>
		);
	};

export default CallbackProfileCreate;